var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66634 11.8763V18.333H0.333008C0.332749 17.3154 0.565442 16.3113 1.01326 15.3975C1.46107 14.4837 2.11212 13.6846 2.91652 13.0614C3.72092 12.4381 4.65732 12.0073 5.65397 11.8019C6.65062 11.5965 7.68106 11.6219 8.66634 11.8763ZM6.99967 10.833C4.23717 10.833 1.99967 8.59551 1.99967 5.83301C1.99967 3.07051 4.23717 0.833008 6.99967 0.833008C9.76217 0.833008 11.9997 3.07051 11.9997 5.83301C11.9997 8.59551 9.76217 10.833 6.99967 10.833ZM11.9997 14.1663V11.2497L16.1663 14.9997L11.9997 18.7497V15.833H9.49967V14.1663H11.9997Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowing);
export default __webpack_public_path__ + "static/media/following.2f580560cdf6d0eb5089e597f096f76c.svg";
export { ForwardRef as ReactComponent };